// extracted by mini-css-extract-plugin
export default {"GalerieContainer":"monCompte_GalerieContainer__w+3Nf","image":"monCompte_image__tfZWQ","contentPage":"monCompte_contentPage__lwm5F","sectionRight":"monCompte_sectionRight__kMwFf"};